import { useSelector } from 'react-redux';
import {useIsTreezorEnabled} from './useIsTreezorEnabled';

export const useIsBankingEnabled = () => {
  const isTreezorEnabled = useIsTreezorEnabled();
  const isEnabledBankingCompany = useSelector(state => state.banking?.isEnabledBanking || false);
  return isTreezorEnabled && isEnabledBankingCompany;
};
